import template from "./invoice-details-modal.html";
import "./invoice-details-modal.less";
import invoiceTransactions from "../../../components/invoice-list/invoice-transactions/invoice-transactions";

class InvoiceDetailsModalController {
	$onInit() {
		this.invoice = this.resolve.invoice;
	}

	handleClose = () => {
		this.modalInstance.dismiss("close");
	};

	handleKeydown = (e) => {
		if(e.key === "Escape" || e.key === "Esc" || e.keyCode === 27) {
			e.preventDefault();
			this.modalInstance.dismiss("escape");
		}
	};

	$postLink() {
		window.addEventListener("keydown", this.handleKeydown, false);
	}

	$onDestroy() {
		window.removeEventListener("keydown", this.handleKeydown);
	}
}

export const showInvoiceDetailsModal = async($uibModal, invoice) => {
	return await $uibModal.open({
		component: "invoice-details-modal",
		size: "lg",
		resolve: {
			invoice: () => invoice
		}
	}).result;
};

export default angular
	.module("vesl.components.invoice-details-modal", [invoiceTransactions])
	.component("invoiceDetailsModal", {
		controller: InvoiceDetailsModalController,
		template,
		bindings: {
			close: "&",
			dismiss: "&",
			modalInstance: "<",
			resolve: "<"
		}
	}).name;
